import React from 'react';
import { CheckIcon, InfoIcon } from 'lucide-react';
import { useFunnel } from '../../contexts/FunnelContext';
import type { StepErrors } from '../../utils/validation';
import type { Arrival } from '../../types/funnel';
import type { StringKey } from '../../data/i18n';
import { ChoiceCard } from './ChoiceCard';
import { StepHeading } from './StepHeading';
import { TextField } from './TextField';
import { HelpAnswers } from './HelpAnswers';
const arrivals: {
  value: Arrival;
  key: StringKey;
}[] = [{
  value: '8am',
  key: 'arr8'
}, {
  value: 'noon',
  key: 'arrNoon'
}, {
  value: '3pm',
  key: 'arr3'
}, {
  value: 'other',
  key: 'arrOther'
}];
export function StepDate({
  errors
}: {
  errors: StepErrors;
}) {
  const {
    t,
    data,
    update
  } = useFunnel();
  const today = new Date().toISOString().slice(0, 10);
  const err = (k: string) => errors[k] ? t(errors[k]!) : undefined;
  return <div data-id="element-711" data-mp="20zc49hrjto0s">
      <StepHeading title={t('dateTitle')} data-id="element-712" data-mp="20z2cppquv8sz" />
      <div className="grid gap-6 md:grid-cols-[260px_1fr] md:items-end" data-id="element-713" data-mp="20y14dt1850ey">
        <TextField label={t('dateLabel')} type="date" min={today} value={data.moveDate} disabled={data.dateUnsure} onChange={v => update({
        moveDate: v
      })} error={err('moveDate')} data-id="element-714" data-mp="7z1wfyj2ligv" />
        <label className="flex min-h-[48px] cursor-pointer items-center gap-3" data-id="element-715" data-mp="h1b7qqm5xfvb">
          <input type="checkbox" className="peer sr-only" checked={data.dateUnsure} onChange={e => update({
          dateUnsure: e.target.checked,
          moveDate: e.target.checked ? '' : data.moveDate
        })} data-id="element-716" data-mp="c282p666n9nc" />
          <span className={`flex h-6 w-6 items-center justify-center rounded-md border-2 peer-focus-visible:outline peer-focus-visible:outline-[3px] peer-focus-visible:outline-magenta ${data.dateUnsure ? 'border-ink bg-ink text-lime' : 'border-ink-300 bg-white'}`} aria-hidden="true" data-id="element-717" data-mp="3ggga8ar3oqzh">
            {data.dateUnsure && <CheckIcon className="h-4 w-4" strokeWidth={3} data-id="element-718" data-mp="31pz62jn2zmyw" />}
          </span>
          <span className="text-[15px] text-ink" data-id="element-719" data-mp="2wsz008q8ek7s">{t('dateUnsure')}</span>
        </label>
      </div>

      <h2 className="mb-3 mt-10 font-display text-2xl font-black text-magenta" data-id="element-720" data-mp="10puawzqlgg0x">{t('arrivalLabel')}</h2>
      <div role="radiogroup" aria-label={t('arrivalLabel')} className="grid grid-cols-2 gap-3 md:grid-cols-4" data-id="element-721" data-mp="15n3x86iosbkj">
        {arrivals.map(a => <ChoiceCard key={a.value} selected={data.arrival === a.value} onSelect={() => update({
        arrival: a.value
      })} title={t(a.key)} data-id="element-722" data-mp="1agynxtwplqt4" />)}
      </div>
      {errors.arrival && <p className="mt-2 text-sm font-medium text-magenta-dark" data-id="element-723" data-mp="hrri09uxdyxu">{t(errors.arrival)}</p>}
      {data.arrival === 'other' && <TextField className="mt-4 max-w-md" label={t('arrOtherLabel')} value={data.arrivalOther} onChange={v => update({
      arrivalOther: v
    })} help={t('anotherTimeCopy')} error={err('arrivalOther')} data-id="element-724" data-mp="mr4dtk3rygck" />}
      <p className="mt-5 flex items-start gap-2 text-sm text-ink-600" data-id="element-725" data-mp="233jhn10nqezu">
        <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-726" data-mp="2339qha3vm1sk" />
        {t('arrivalNote')}
      </p>

      <HelpAnswers screen="stepDate" className="mt-10" data-id="element-727" data-mp="2777m3atzsugv" />
    </div>;
}